var exports = {
  "HeroPagination": "HeroPagination__H5tR7v",
  "HeroPagination--dark": "HeroPagination--dark__39Lqfr",
  "HeroPagination__chapters": "HeroPagination__chapters__bLRWC8",
  "HeroPagination__chapters_viewport": "HeroPagination__chapters_viewport__vAeGXk",
  "HeroPagination__chapters_list": "HeroPagination__chapters_list__msp0XY",
  "HeroPagination__chapters_item": "HeroPagination__chapters_item__8uFAeF",
  "HeroPagination__chapters_button": "HeroPagination__chapters_button__tFR1-t",
  "HeroPagination__chapters_progress": "HeroPagination__chapters_progress__dmt86Y",
  "HeroPagination__chapters_label": "HeroPagination__chapters_label__slzXuy",
  "HeroPagination__controls": "HeroPagination__controls__Eots1d",
  "HeroPagination__playback": "HeroPagination__playback__I6F7TB",
  "HeroPagination__controls_pagination": "HeroPagination__controls_pagination__VA084m",
};

__webpack_require__.r(module.exports = exports);
